// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDescriptionContent.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

!(function() {


  var React = require('react');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var EventsUtils = require('EventUtils');

  var dashboardConstants = require('logic/data/Izenda.DashboardConstants');
  var propTypes = {
    save: React.PropTypes.func,
    description: React.PropTypes.string
  };
  const { cloneDeep } = require('lodash/fp');

  var DashboardDescriptionContent = React.createClass({
    propTypes: propTypes,

    getInitialState: function() {
      return this.populateSate(this.props);
    },

    componentWillReceiveProps: function(nextProps) {
      var newState = this.populateSate(nextProps);
      this.setState(newState);
    },

    /**
     * Build state information.
     * @param {Object} props
     * @return {Object}
     */
    populateSate: function(props) {
      var description = props.description || '';
      return {
        description: description,
        originalDesc: cloneDeep(description)
      };
    },

    /**
     * Handle close popup.
     * @param {String} type
     */
    onClosing: function(type) {
      var props = this.props;
      if (type === 'cancel') {
        return props.onReject();
      }

      var state = this.state;
      var description = state.description;
      var originalDesc = state.originalDesc;

      if (type === 'accept') {
        description !== originalDesc && props.save(description);
        return props.onAccept();
      }
    },

    /**
     * Handle change value of description control.
     * @param {String} type
     */
    onChangeDescription: function(value) {
      this.setState({
        description: value
      });
    },

    /**
     * Render body of popup.
     * @param {Object}
     */
    render: function() {
      var state = this.state;

      return (
        <GridLayout>
          <GridLayout.Row>
            <GridLayout.Col cols={12}>
              <span>{dashboardConstants.DESCRIPTION.DESCRIPTION_LABEL}</span>
            </GridLayout.Col>
          </GridLayout.Row>
          <GridLayout.Row>
            <GridLayout.Col cols={12}>
              <textarea
                className="form-control"
                rows="3"
                value={state.description}
                onChange={EventsUtils.notifyChange(this.onChangeDescription, EventsUtils.INPUT)}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      );
    }
  });

  module.exports = {
    DashboardDescriptionContent: DashboardDescriptionContent,
    propTypes: propTypes,
    constants: dashboardConstants.DESCRIPTION
  };
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardDescription/Izenda.DashboardDescriptionContent.jsx